import React, { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import LogInSection from '../Components/verification/LogInSection';

const VerificationPage: React.FC = () => {
  const [status, setStatus] = useState<number>(0);
  const { t } = useTranslation();

  return (
    <Flex w="100%" minH="auto" direction="column" align="center" bg="#FFFFFF">
      <Flex w="100%" maxW="1200px" direction="column" align="center" pt="50px" pb="100px" px="24px">
        <Flex direction="column" align="center" mb="50px">
          <Text
            fontFamily="'Open Sans'"
            fontWeight={600}
            fontSize="30px"
            lineHeight="133%"
            textAlign="center"
            color="#000000"
            mb="10px"
          >
            {t('verification.title')}
          </Text>
          <Text
            fontFamily="'Open Sans'"
            fontWeight={600}
            fontSize="20px"
            lineHeight="120%"
            textAlign="center"
            color="#000000"
          >
            {t('verification.subtitle')}
          </Text>
        </Flex>

        <LogInSection status={status} setStatus={setStatus} />
      </Flex>
    </Flex>
  );
};

export default VerificationPage;
